import React from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';

import { RootState } from '../../../redux/store';
import { PageContainer, PageSection } from '../../../ui';
import { colors } from '../../../theme/tokens';

/* Customer → Favorite testers */
const FavoriteTesters: React.FC = () => {
  const { favoriteTesters, resolution } = useSelector((state: RootState) => state);
  const isMobile = resolution.device === 'mobile' || resolution.device === 'mobile-tablet';
  const testers: any[] = Object.values(favoriteTesters.byId);

  return (
    <PageContainer isMobile={isMobile}>
      <PageSection title={`Favorite testers${testers.length ? ` (${testers.length})` : ''}`} padding={isMobile ? 1.5 : 2.5}>
        {testers.length ? (
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 1.5 }}>
            {testers.map((tester) => (
              <Box
                key={tester.id}
                component={RouterLink}
                to={`/account/customer/favorite/${tester.id}`}
                sx={{
                  display: 'flex',
                  gap: 1.5,
                  alignItems: 'center',
                  p: 1.5,
                  border: `1px solid ${colors.dividerBlue}`,
                  borderRadius: 2,
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': { backgroundColor: colors.primaryTint },
                }}
              >
                <Avatar src={tester.avatarUrl || undefined} alt={tester.firstName} sx={{ width: 48, height: 48 }} />
                <Box sx={{ minWidth: 0 }}>
                  <Typography noWrap sx={{ fontWeight: 600 }}>{tester.firstName} {tester.lastName}</Typography>
                  <Typography sx={{ fontSize: 12, color: colors.textGrey }}>{tester.country}</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Rating value={Number(tester.rating) || 0} precision={0.25} readOnly size="small" />
                    <Typography sx={{ fontSize: 12, color: colors.textGrey }}>{Number(tester.rating || 0).toFixed(2)}</Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No favorite testers so far. Add testers from a cycle&apos;s Active Testers tab.
          </Typography>
        )}
      </PageSection>
    </PageContainer>
  );
};

export default FavoriteTesters;
